<template>
  <Modal v-bind="$attrs" v-on="$listeners">
    <template #contents>
      <div class="tos">
        <JpText v-if="$i18n.locale === 'ja'" />
        <EnText v-else />
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/molecules/Modal'
import JpText from './JpText'
import EnText from './EnText'

/**
 * 利用規約モーダル
 */
export default {
  name: 'TosModal',
  components: {
    Modal,
    JpText,
    EnText,
  },
}
</script>

<style lang="postcss" scoped>
.tos {
  border: 1px solid var(--border-color);
  margin: 0 16px 16px;
  -webkit-overflow-scrolling: touch;
  overflow-y: auto;
  padding: 16px 8px;
  white-space: pre-line;
  word-break: normal;

  @media screen and (min-width: 672px) {
    margin: 0 24px 24px;
    padding: 16px;
  }
}
</style>
